module.exports = __webpack_public_path__ + "img/Unidad8-4.3466310e.png";